module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "col",
    attrs: {
      "id": "nav"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/",
      "tag": "div"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../ofo/static/img/logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('ul', _vm._l((_vm.navItems), function(item) {
    return _c('li', {
      on: {
        "mouseover": function($event) {
          _vm.addClass($event)
        },
        "mouseleave": function($event) {
          _vm.rmClass($event)
        },
        "click": function($event) {
          _vm.toLink(item.link, $event)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                ")])
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7c29b346"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 23
// module chunks = 0